import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { debounce } from '../../utilities/behavior-helpers/index.js';
import '../../utilities/dom-helpers/index.js';
import css_248z from './parallax.scss.js';

const setOpacity = () => {
    const result = window.scrollY / window.innerHeight >= 1
        ? 1
        : window.scrollY / window.innerHeight;
    return result.toFixed(2);
};
const adjustPosOnScroll = (
// eslint-disable-next-line no-use-before-define
host, footer, content, blockHeight) => {
    if (window.scrollY + window.innerHeight + footer.offsetHeight >=
        document.body.scrollHeight) {
        host.style.top = 'auto';
        host.style.bottom = '40px';
    }
    else {
        const topPosition = Math.round((window.scrollY * (content.offsetHeight - blockHeight)) /
            (document.body.scrollHeight - window.innerHeight * 2));
        host.style.top = `${topPosition}px`;
        host.style.bottom = 'auto';
    }
};
class Parallax extends s {
    constructor() {
        super(...arguments);
        this.blockOpacity = 0;
    }
    init() {
        const content = document.querySelector('.content');
        const footer = document.querySelector('cvt-footer');
        const host = this;
        let blockHeight;
        if (!content)
            return;
        window.addEventListener('load', () => {
            blockHeight = Math.round(content.offsetHeight * 0.75);
            host.style.height = `${blockHeight}px`;
        });
        document.addEventListener('scroll', debounce(() => {
            host.style.opacity = setOpacity();
            adjustPosOnScroll(host, footer, content, blockHeight);
        }, 100));
    }
    render() {
        this.init();
        return x `<div class="parallax" style='background-image:url("${this.background}")'></div>`;
    }
}
Parallax.styles = css_248z;
__decorate([
    n({ type: String })
], Parallax.prototype, "background", void 0);
__decorate([
    t()
], Parallax.prototype, "blockOpacity", void 0);
customElements.define('parallax-bg', Parallax);

export { Parallax, adjustPosOnScroll, setOpacity };
